import { useMemo } from 'react';
import { differenceInHours } from 'date-fns';

import { useOrigins } from '@components/features/Compliance/queries';
import { PageProtectionFeatureStatus } from '@components/features/Compliance/types';

export function usePageProtectionStatus(): PageProtectionFeatureStatus {
  const origins = useOrigins();

  const status = useMemo<PageProtectionFeatureStatus>(() => {
    if (!origins.data) {
      return { tier: 'not-enrolled' };
    } else {
      return origins.data.feature;
    }
  }, [origins.data]);

  return status;
}

export function usePageProtectionEnabled(): boolean {
  const status = usePageProtectionStatus();

  if (status.tier === 'disabled') {
    return false;
  }

  if (status.tier === 'trial') {
    const hours = differenceInHours(new Date(status.endDate), new Date());
    return hours > 0;
  }

  return true;
}
